import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { formatDollarsWithOptionalCents } from '../../../../../../utils/formatting';
import Timestamp from '../../../../../../Timestamp';
import UserAvatar from '../../../../../../User/Avatar/UserAvatar';
import UserLink from '../../../../../../User/Link/UserLink';
import Stack from '../Stack';
import s from './OwnerRow.scss';
const OwnerRow = ({ user, sellPrice, sellTimestamp })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Section, {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['avatar-and-name']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        size: 32,
        user: user
    }), /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(Heading, {
        className: s['username-headnote']
    }, t('sidebar.exclusives.currentOwner.usernameHeadnote')), /*#__PURE__*/ React.createElement(UserLink, {
        className: s['username'],
        user: user
    }))), /*#__PURE__*/ React.createElement(Stack, {
        className: s['details']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['detail']
    }, t('sidebar.exclusives.currentOwner.detail.sellPrice', {
        price: formatDollarsWithOptionalCents(sellPrice)
    })), /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: sellTimestamp,
        className: s['detail']
    })));
};
OwnerRow.displayName = 'OwnerRow';
export default OwnerRow;
